/**
 * DpInvestingStyleService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpInvestingStyleService {
    createInvestingStyle = (body) => {
        return apiClient.post("/context/investingStyle", body);
    }

    editInvestingStyle = (body) => {
        return apiClient.post("/context/investingStyle/edit", body);
    }

    deleteInvestingStyle = (id) => {
        return apiClient.post("/context/investingStyle/delete", { id });
    }
}
